<script setup lang="ts">
import type { ButtonVariants } from '~ds/components/ui/button'
import type { PaginationPrevProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { buttonVariants } from '~ds/components/ui/button'
import { Icon } from '~ds/components/ui/icon'
import { ICONS } from '~ds/lib/icons'
import { cn } from '~ds/lib/utils'
import { PaginationPrev, useForwardProps } from 'reka-ui'

const props = withDefaults(defineProps<PaginationPrevProps & {
  size?: ButtonVariants['size'];
  class?: HTMLAttributes['class'];
}>(), {
  size: 'default',
})

const delegatedProps = reactiveOmit(props, 'class', 'size')
const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <PaginationPrev
    data-slot="pagination-previous"
    :class="cn(buttonVariants({ variant: 'ghost', size }), 'gap-1 rounded-md px-2.5 sm:pr-2.5', props.class)"
    v-bind="forwarded"
  >
    <slot>
      <Icon :name="ICONS.arrowLeft" size="sm" />
      <span class="hidden sm:block">Previous</span>
    </slot>
  </PaginationPrev>
</template>
